
import React, { useState } from 'react';
import { AppBar, Tabs, Tab } from '@mui/material';
import MtableActivos from './Mtable_ActivosInformacion.js'
import ResumenActivos from './ResumeActivos.js';

const MainActivos = ({ params }) => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div>
            <AppBar position="static" style={{ backgroundColor: '#2c2a29' }}>
                <Tabs value={value} onChange={handleChange} textColor="inherit" indicatorColor="secondary">
                    <Tab label="Activos de Informacion" style={{ color: "#ffffff", padding: "3px 7px 3px" }} />
                    <Tab label="Resumen" style ={{color: "#ffffff", padding: "3px 7px 3px"}}/>
                </Tabs>
            </AppBar>

            {value === 0 && <MtableActivos params={params} />}
            {value === 1 && <ResumenActivos params={params}/>}
        </div>
    );
};

export default MainActivos;

